import { Component } from '@angular/core';

import { HeaderComponent } from '@app/common/header/header.component';

@Component({
  selector: 'app-page-not-found',
  imports: [HeaderComponent],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
})
export class NotFoundComponent {}
